import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.l61_1 = delegate;
        this.m61_1 = call;
      }
      *v5f(frame, $completion) {
        yield* this.l61_1.v5f(frame, $completion);
        return Unit_instance;
      }
      *g4o($completion) {
        yield* this.l61_1.g4o($completion);
        return Unit_instance;
      }
      r5f(_set____db54di) {
        this.l61_1.r5f(_set____db54di);
      }
      s5f() {
        return this.l61_1.s5f();
      }
      t5f() {
        return this.l61_1.t5f();
      }
      u5f() {
        return this.l61_1.u5f();
      }
      gw() {
        return this.l61_1.gw();
      }
      q5f(negotiatedExtensions) {
        this.l61_1.q5f(negotiatedExtensions);
      }
      p5f() {
        return this.l61_1.p5f();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.n61_1 = session;
        this.o61_1 = call;
      }
      *v5f(frame, $completion) {
        yield* this.n61_1.v5f(frame, $completion);
        return Unit_instance;
      }
      *g4o($completion) {
        yield* this.n61_1.g4o($completion);
        return Unit_instance;
      }
      r5f(_set____db54di) {
        this.n61_1.r5f(_set____db54di);
      }
      s5f() {
        return this.n61_1.s5f();
      }
      t5f() {
        return this.n61_1.t5f();
      }
      u5f() {
        return this.n61_1.u5f();
      }
      gw() {
        return this.n61_1.gw();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
